module.exports = __webpack_public_path__ + "static/03-illustration-f255e45d90bcf25c8784d8fd15061db1.svg";